import { render, staticRenderFns } from "./ScanBarcode.vue?vue&type=template&id=38dda574&scoped=true&"
import script from "./ScanBarcode.vue?vue&type=script&lang=js&"
export * from "./ScanBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dda574",
  null
  
)

export default component.exports